import React from "react";
import { Paragraph } from "auth/components";

export const SignInLink = () => <a href="/sign_in">Return to Sign in</a>;
export const ssaURL =
  "https://www.solarwinds.com/-/media/solarwinds/swdcv2/legal/legal-documents/solarwinds-software-services-agreement-combined-cloud-and-core.ashx?rev=3ac3d4add2cb4dcebe326e038a6f2f80&hash=DDB5F8A24A2E65740475B5CC3AEE50A8";
export const privacyUrl = "https://www.solarwinds.com/legal/privacy";

export const LegalAgreement = () => (
  <Paragraph>
    By signing up you confirm that you accept to opt in to occasional emails
    from AppOptics.
  </Paragraph>
);
